@for (item of items(); track $index) {
    @if (item.link) {
        <a [attr.aria-label]="item.title" [class]="'bar tone-' + item.tone" [matTooltip]="item.title ?? ''" [queryParams]="item.queryParams" [routerLink]="item.link"></a>
    } @else {
        <span [class]="'bar tone-' + item.tone" [matTooltip]="item.title ?? ''"></span>
    }
}
